import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';
import { FinanceService } from 'src/modules/features/contractor/services';
import { UploadProofOfPaymentModal } from '../../../modals';
import { AuthenticationService } from 'src/modules/core/services';

@Component({
  selector: 'app-upload-proof-of-payment',
  templateUrl: './upload-proof-of-payment.component.html',
  styleUrls: ['./upload-proof-of-payment.component.scss'],
})
export class UploadProofOfPaymentComponent implements OnInit {
  proofOfPayments = [];
  pending;
  gatewayTransactionId;
  error;
  success;
  uploaded: boolean;
  baseUrl = environment.API_SERVER;
  ESERVICES_URL = environment.ESERVICES_URL;
  token;
  paymentTransaction;
  invoiceDetails = {
    invoiceType: null,
    validityPeriod: null,
    serviceStartDate: null,
    serviceEndDate: null,
  };

  constructor(
    private modalService: SuiModalService,
    private service: FinanceService,
    private route: ActivatedRoute,
    private auth: AuthenticationService,
    private router: Router
  ) {
    this.token = window.localStorage.getItem('jwt');
    this.gatewayTransactionId = this.route.snapshot.queryParamMap.get(
      'transactionReference'
    );
    if (this.gatewayTransactionId == null) {
    } else {
      this.getPaymentTransaction();
    }
    this.uploaded = false;
    // route to contractor page if user is signed in

    const user =
      this.auth.userValue || JSON.parse(window.localStorage.getItem('user'));
    if (
      user &&
      user?.organizationId?.organizationTypeId?.organizationTypeId ==
        'contractor'
    ) {
      this.router.navigate(
        ['/contractor/payment/foreign-payment/upload-proof-of-payment'],
        {
          queryParams: {
            transactionReference: this.gatewayTransactionId,
          },
        }
      );
    }
  }

  getPaymentTransaction() {
    this.pending = true;
    this.service
      .getPaymentTransactionDetail({
        gatewayTransactionRefId: this.gatewayTransactionId,
      })
      .subscribe(
        (res) => {
          this.paymentTransaction = res;
          console.log('Payment transaction ', this.paymentTransaction);
          if (this.paymentTransaction.invoiceNumber != null) {
            this.getInvoiceDetails(this.paymentTransaction.invoiceNumber);
          } else {
            this.pending = false;
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getInvoiceDetails(invoiceNumber) {
    this.service
      .getInvoiceDetailsWithInvoiceNumber({
        invoiceNumber: invoiceNumber,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.invoiceDetails = res;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  uploadProofOfPayment() {
    this.modalService
      .open(
        new UploadProofOfPaymentModal(
          'Upload Proof of Payment',
          null,
          false,
          this.gatewayTransactionId,
          ModalSize.Tiny
        )
      )
      .onApprove((eq) => {
        this.success = 'Proof of payment uploaded successfully';
        this.proofOfPayments.push(eq);
        this.uploaded = true;
      })
      .onDeny(() => console.log('cancel'));
  }

  viewDocument(item) {
    const url = `${this.baseUrl}/finance/public/media/?media=${item['path']}`;
    window.open(url, '_blank');
  }

  isApplicationFeePayment(paymentInfo: any) {
    const createdBy = JSON.parse(paymentInfo.createdBy);
    if (!createdBy) return false;
    const link = createdBy.name;
    const end = link.split('/').slice(-1);
    if (
      /payment-summary\?id=/.test(end) &&
      link.toLowerCase().includes('tamsy')
    )
      return true;
  }

  goToPaymentSummary(paymentInfo: any) {
    const createdBy = JSON.parse(paymentInfo.createdBy);
    const link = createdBy.name;
    window.open(link, '_self');
  }
  goToWallet() {
    if (this.uploaded) {
      if (this.token) {
        this.router.navigateByUrl(
          `/contractor/wallet/transactions/dollar?status=true&message=Your payment has been completed successfully. Please note that the transaction will be approved by an NCC user before it reflects in your balance. Scroll down to view the record of your pending transaction.`
        );
      } else {
        const link = `${this.ESERVICES_URL}/redirect?route=/contractor/wallet/transactions&token=${this.token}`;
        window.open(link, '_self');
      }
    } else {
      if (this.token) {
        this.router.navigateByUrl(`/contractor/wallet/transactions/dollar`);
      } else {
        const link = `${this.ESERVICES_URL}/redirect?route=/contractor/wallet/transactions/dollar&token=${this.token}`;
        window.open(link, '_self');
      }
    }
  }

  ngOnInit(): void {}
}
